var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-block"},[_c('ChannelMarker',{attrs:{"channel":_vm.$t('blocks.msgs')}}),_c('ChatNameChange'),_c('ChatMessageList',{attrs:{"width":_vm.controls.freqVal}}),_c('ChatMessageInput')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }